module.exports = __webpack_public_path__ + "static/media/07 - Snare.e31a5aff.wav";